import iconPlay from './iconPlayVideo.svg'
import iconUpArrow from './upArrow.svg'

export default {
  iconPlay,
  iconUpArrow,
}
